import { StyleSheet } from 'aphrodite'

import main from './main'
import story from './story'
import offer from './offer'

export default {
  main: StyleSheet.create(main),
  story: StyleSheet.create(story),
  offer: StyleSheet.create(offer)
}



// WEBPACK FOOTER //
// ./src/components/About/style/index.js